import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { ChevronRight } from 'lucide-react';

export const Arrow = ({ color, sx, ...rest }) => (
  <Flex alignItems="center" sx={{ position: 'relative', ...sx }} {...rest}>
    <Box width="100%" height="1px" bg={color} />
    <Box
      as={ChevronRight}
      width="16px"
      height="16px"
      aria-hidden="true"
      sx={{ position: 'absolute', right: '-5px', top: '50%', transform: 'translateY(-50%)' }}
    />
  </Flex>
);

Arrow.propTypes = {
  color: PropTypes.string,
  sx: PropTypes.object,
};

Arrow.defaultProps = {
  color: 'purple.500',
  sx: {},
};
